import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'Database' })({
    wrapper: {
        display: 'flex',
        flexDirection: 'column',
        gap: 80,
        width: 1440,
        maxWidth: '100%',
        margin: 'auto'
    },
    bulletinTypesTitle: {
        fontSize: 24
    },
    bulletinTypesButton: {
        padding: 16,
        fontSize: 16,
        fontWeight: 500,
        lineHeight: '16px'
    }
});
